import { useEffect, useState } from "react";
import api from "../api";

let cache = null;

// Fetches the earned-badge map once per page load and shares it across all cards.
export default function useBadgeMap() {
  const [map, setMap] = useState({});
  useEffect(() => {
    if (!cache) cache = api.get("/products/badges").then(({ data }) => data || {}).catch(() => ({}));
    cache.then(setMap);
  }, []);
  return map;
}
